import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { FaxFileTypeOption } from '../models/fax-file-type-option.interface';
import { faxFileTypeOptionSelectors } from '../state/fax-file-type-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: FaxFileTypeSelectComponent,
        },
    ],
    selector: 'ndt-fax-file-type-select',
    templateUrl: './fax-file-type-select.component.html',
    standalone: false
})
export class FaxFileTypeSelectComponent extends LcsSingleSelectBase<FaxFileTypeOption> implements OnInit {
   faxFileTypes: Observable<FaxFileTypeOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.faxFileTypes = this.store.pipe(select(faxFileTypeOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: FaxFileTypeOption | null): string | null {
      return item ? item.faxFileTypeId : null;
   }

   trackBy(item: FaxFileTypeOption | null) {
      return item ? item.faxFileTypeId : null;
   }
}
